import {makeStyles} from "@fluentui/react-components";
import {greenTheme} from "./theme";

export const useStyles = makeStyles({
    main: {
        width: '100%',
    },
    container: {
        margin: '0 8px',
        padding: '20px',
        borderRadius: '6px'
    },
    flexColumn: {
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
    },
    flexRow: {
        display: 'flex',
    },
    highlightCard: {
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
        padding: '16px',
        borderRadius: '8px'
    },
    title: {
        fontWeight: '700',
        fontSize: '20px',
        backgroundColor: 'white',
        color: 'black',
        borderRadius: '8px',
        paddingTop: '8px',
        paddingBottom: '8px',
        width: 'fit-content',

    },
    wordSpan: {
        margin: '0 4px',
        whiteSpace: 'nowrap'
    },
    contentWrapper: {
        display: 'flex',
        gap: '12px',
        padding: '0 8px'
    },
    description: {
        flex: 1,
        fontWeight: '700',
        color: 'black',
        display: 'flex',
        alignItems: 'center',
    },
    flexWrap: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    imageContainer: {
        flex: 1,
        '& > div': {
            border: `1px solid ${greenTheme.outliendBtn}`,
            backgroundColor: 'white',
            padding: '8px',
            borderRadius: '8px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }
    },
    productCard: {
        display: 'flex',
        gap: '20px',
        padding: '10px',
        backgroundColor: 'white',
        borderRadius: '8px',
        border: `1px solid ${greenTheme.outliendBtn}`,
    },
    productImg: {
        display: 'flex',
        flex:1,
        alignItems: 'center',
        justifyContent: 'center',
        width:'100%',
    },
    productInfo: {
        display: 'flex',
        flex:1,
        flexDirection: 'column',
    },
    label: {
        fontWeight: '700',
        color: 'white',
        backgroundColor: 'black',
        width: '20px',
        padding: '4px',
        borderRadius: '8px'
    },
    productLabel: {
        fontWeight: '700',
        color: 'white',
        backgroundColor: '#f87171',
        width: 'fit-content',
        padding: '4px',
        borderRadius: '8px',
        fontSize: 'medium'
    },
    value: {
        fontWeight: '700',
        fontSize: '20px'
    },
    fixedBottom: {
        position:'fixed',
        bottom:0,
        right:0,
        left:0,
        padding:'20px',
        backgroundColor:'white',
    },
    roundedBtn: {
        width:'100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '10px',
        padding:'10px',
        fontWeight:'700',
        fontSize:'medium'
    },
    hintCard: {
        display: 'flex',
        flexDirection:'column',
        gap: '3px',
        padding: '10px',
        backgroundColor: 'white',
        borderRadius: '8px',
        border: `1px solid ${greenTheme.outliendBtn}`
    },
    hintTitle: {
        fontWeight: '700',
        fontSize: '20px',
        backgroundColor: 'white',
        color: '#6b7280',
        borderRadius: '8px',
        padding: '8px',
        width: 'fit-content',
    },
    primaryBtn: {
        backgroundColor: greenTheme.primaryColor,
        color: 'white',
        border: `1.5px solid ${greenTheme.primaryColor}`,
    },
    outlinedBtn: {
        backgroundColor: 'white',
        color: 'black',
        border: `1.5px solid ${greenTheme.outliendBtn}`,
    },
    underlinedBtn: {
        backgroundColor: 'transparent',
        color: 'gray',
        borderBottom: '1px solid gray',
        fontSize: 'x-small',
        borderTop: 'none',
        borderLeft: 'none',
        borderRight: 'none',
        borderRadius:'0px',
        // selectors: {
        //     '&:hover': {
        //         color: 'darkgray',
        //         borderBottomWidth: '2px',
        //         cursor: 'pointer'
        //     }
        // }
    },
    guideMessage: {
        fontSize: 'small',
        fontWeight: 'bold',
    }
});

export const useAnswerInputStyles = makeStyles({
    main:{
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        height: '10%'
    },
    root: {
        display: 'flex',
        gap: '8px',
    },
    form: {
        display: 'flex',
        gap: '8px',
        padding: '8px',
        justifyContent:'center',
        borderRadius: '8px',
    },
    roundBtn: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '10px',
        border: '0px',
    },
    input: {
       border:'0px', borderRadius:'10px', backgroundColor:'white', padding: '10px', height:'100%'
    }
})

